<template>
  <BasicDialog :model-value="show" controlled force-close padding="none" size="lg">
    <template #title>
      <h4
        class="text-2xl font-bold text-primary py-4 md:py-6 px-6 md:px-10 border-b border-[#E3E3E3]"
      >
        {{ t('dialog.termOfUse.title') }}
      </h4>
    </template>
    <div class="py-4 md:py-6 px-6 md:px-10 [&~.dialog-footer]:!mt-0">
      <!-- <iframe :src="pdfUrl" class="w-full border-none" height="450px" /> -->
      <div class="w-full h-[55vh] overflow-y-auto">
        <Pdf :url="pdfUrl" :on-load="() => (pdfLoaded = true)" />
        <div ref="target" class="h-1 w-full -mt-[1500px]" />
      </div>
    </div>
    <template #footer>
      <div class="w-full">
        <div
          class="flex justify-center gap-x-4 items-center py-4 md:py-4 px-6 md:px-10 border-t border-[#E3E3E3] w-full shadow-lg shadow-[#0000001A]"
        >
          <BasicBtn color="textual" size="large" @click="logout()">{{
            t('dialog.termOfUse.logout')
          }}</BasicBtn>
          <BasicBtn
            color="primary"
            :disabled="!hasReadAllTerms && ENABLE_SCROLL_TO_ACCEPT"
            size="large"
            :loading="isPending"
            @click="acceptTerms"
            >{{
              !hasReadAllTerms && ENABLE_SCROLL_TO_ACCEPT
                ? t('dialog.termOfUse.scrollToAccept')
                : t('dialog.termOfUse.accept')
            }}</BasicBtn
          >
        </div>
        <div
          v-if="ENABLE_SCROLL_TO_ACCEPT && !hasReadAllTerms"
          class="text-center text-primary bg-[#6859A733]/20 font-bold py-4 px-4"
        >
          <p>{{ t('dialog.termOfUse.pleaseScrollToBottom') }}</p>
        </div>
      </div>
    </template>
  </BasicDialog>
</template>

<script setup lang="ts">
  import { ToastAction } from '#components'
  import type { Content } from 'vue3-toastify'

  const { t, locale } = useI18n()
  const show = defineModel<boolean>({ default: false })
  const { updateAgreementAccepted, setAlreadyAgreed, logout } = useAuthStore()
  const pdfUrl = computed(() => {
    return `/tou/Terms%20of%20Use%20GMP+%20Platform%20-%20${locale.value.toUpperCase()}.pdf`
  })
  const { $toast } = useNuxtApp()

  const { mutate: acceptTerms, isPending } = useMutation({
    mutationFn: () => {
      return useApiClient<{ id: string }>('/portal/proxy/terms-of-use', {
        method: 'POST',
      })
    },
    throwOnError: false,
    // onSettled: async () => {
    //   // cant rely on this beacuse it's not updated until you log in again
    //   await fetchClientPrincipal()
    // },
    onError: (err) => {
      const error = err as Error & {
        result?: {
          Message: string
        }
      }
      $toast.error(ToastAction as Content, {
        data: {
          message: error?.result?.Message ?? '',
        },
        autoClose: 2000,
        closeOnClick: true,
        closeButton: false,
        toastId: 'TERMS_OF_USE_ERROR',
      })
    },
    onSuccess: () => {
      setAlreadyAgreed(true)
      updateAgreementAccepted(true)
    },
  })

  const ENABLE_SCROLL_TO_ACCEPT = true
  const pdfLoaded = ref(false)
  const hasReadAllTerms = ref(false)
  const target = useTemplateRef<HTMLDivElement>('target')
  useIntersectionObserver(target, ([entry], _observerElement) => {
    if (entry.isIntersecting && pdfLoaded.value) {
      hasReadAllTerms.value = true
    }
  })
</script>
